import { render, staticRenderFns } from "./point_goods.vue?vue&type=template&id=1c9bc5cc&scoped=true"
import script from "./point_goods.vue?vue&type=script&lang=js"
export * from "./point_goods.vue?vue&type=script&lang=js"
import style0 from "./point_goods.vue?vue&type=style&index=0&id=1c9bc5cc&prod&lang=scss&scoped=true"
import style1 from "./point_goods.vue?vue&type=style&index=1&id=1c9bc5cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9bc5cc",
  null
  
)

export default component.exports